import { iWell } from '../@types/plataforma.type';
import {api} from './api';

export const getWellApi = (plataforma: string | null): Promise<any> => {
    return api.get('well/', {params:{plataforma}}).then(res => {
        return res.data.find((p:iWell)=>p.current)
    })
}